module.exports = __webpack_public_path__ + "d55551b046991eed1c59d66e709bb018.pdf";